import styled from 'styled-components';
import { DebounceInput } from 'react-debounce-input';
import SearchImage from '../../assets/icons/general/search.svg';

const Container = styled.div(({ theme }) => {
  const { color, shadow } = theme;

  return `
    background-color: ${color.grayscale[1000]};
    border-radius: 52px;
    box-shadow: ${shadow.dialog};
    display: flex;
    flex-flow: row nowrap;
    position: relative;
    padding: 12px 16px;

    &:focus-within {
      outline: 2px auto -webkit-focus-ring-color;
    }
  `;
});

const SearchIcon = styled.img(({ theme }) => {
  const { type } = theme;

  return `
    display: block;
    height: ${type.size.larger};
    width: ${type.size.larger};
  `;
});

const Input = styled(DebounceInput)(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.small};
    color: ${color.grayscale[0]};
    outline: none;
    margin-left: 0.5rem;
  `;
});

const Label = styled.label`
  position: absolute;
  height: 1px;
  width: 1px;
  left: -999999px;
  top: 0;
  overflow: hidden;
`;

const Search = ({ callback, value, name }) => {
  return (
    <Container>
      <SearchIcon src={SearchImage} alt="" />

      <Label htmlFor="playerSearch">Search</Label>
      <Input
        type="search"
        name={name}
        id="playerSearch"
        value={value}
        placeholder="Search players"
        debounceTimeout={500}
        onChange={callback}
      />
    </Container>
  );
};

export default Search;
